<template>
    <div class="row mx-0 w-100 carousel-container" :class="{'disabled-input' : disableInput }">
        <h3 v-if="label" class="label-carousel" :class="{'no-sel-active' : noSelActive}"> {{ label }} </h3>
        <div v-if="showControls" class="row mx-0 w-100 controls-container">
            <div class="control-prev"
                 :class="{'expanded' : isFirstSelected}"
                 @click="controlDir(-1)"
            >
                <i class="ecom-chevron-left"/>
            </div>
            <div class="control-next"
                 :class="{'expanded' : isLastSelected}"
                 @click="controlDir(1)"
            >
                <i class="ecom-chevron-right"/>
            </div>
        </div>
        <div class="col-12 px-0 vue-cart-type-carousel" :class="{ 'single-item' : options.length == 1 }" :id="elementId" :ref="elementId">
            <div
                v-for="(option, index) in options"
                class="row snap-slider-item"
                :key="option.id"
                :class="{'option-active': value && option.id === value.id}"
                :data-id="option.id"
                :data-order="index"
                :data-isdefaultsku="option.default"
                @click="updateOption(option, true)"
                ref="carouselItems"
            >
                <img
                    itemprop="image"
                    class=""
                    :alt="option.description"
                    :src="getOptionImage(option, false)"
                    width="94"
                    height="94"
                />

                <div v-if="option.stock" class="row mx-0 item-description" >
                    {{ option.description }}
                </div>
                <template v-else>
                    <div class="label-container">
                        <span class="label-out-of-stock">
                            {{
                                option.variantInfoData.groupStatus == 'CS'
                                    ? kStrings.kCOMING_SOON
                                    : kStrings.kPROD_STOCK_OUT
                            }}
                        </span>
                    </div>
                    <div class="row mx-0 item-description">
                        {{ option.description }}
                    </div>
                </template>
            </div>
        </div>
        <hr v-show="noSelActive" class="no-sel-border">
        <slot name="buyButton"/>
    </div>
</template>

<script>


import {storeCombos} from '@/store/comboCart';
import {isEmpty} from 'lodash-es';

import utilities from '@/Utilities/common';
import operatingSystem from '@/Utilities/operating-system';

export default {
    storeCombos,
    name: 'QuickCarousel',
    components: {},
    props: {
        label: String,
        options: Array,
        optionType: String,
        value: Object,
        defaultValue: {
            type: Object,
            default: null,
        },
        itemId: { // for multiple widgets
            type: String,
            default: '0',
        },
        currentSelection: String,
        disableInput: {
            type: Boolean,
            default: false,
        },
        emptySelectionWarning: {
            type: Boolean,
            default: false,
        },
    },
    data: function() {
        return {
            carouselElem: null,
            selectedElement: null,
            optionsLength: 0,
            isFirstSelected: false,
            isLastSelected: false,
            weirdBrowser: false,
        };
    },
    computed: {
        elementId() {
            return 'carouselPicker-' + this.itemId;
        },
        kStrings(){
            return storeCombos.getters.kStrings;
        },
        noSelActive() {
            return !this.defaultValue && this.emptySelectionWarning;
        },
        carouselCenter: function() {
            this.$nextTick(() => {
                return this.carouselElem.getBoundingClientRect().width / 2;
            });
            return this.carouselElem.getBoundingClientRect().width / 2;
        },
        showControls() {
            //return this.options.length > 4;
            return this.carouselElem ? utilities.isScrollableElement(this.carouselElem) : false
        },
    },
    methods: {
        scrollToSelected(resetToVar = null, resetDefault = false) {
            if (this.value || resetToVar) {
                let defaultSelected = !resetToVar ? this.$refs.carouselItems.find(
                    element => element.dataset.id == this.value.id) : this.$refs.carouselItems.find(
                    element => element.dataset.id == resetToVar);
                if (resetDefault && !isEmpty(this.$refs.carouselItems.find(element => element.dataset.isdefaultsku))) {
                    defaultSelected = this.$refs.carouselItems.find(element => element.dataset.isdefaultsku);
                }

                if (defaultSelected) {
                    this.carouselElem.scrollTo({
                        top: 0,
                        left: defaultSelected.offsetLeft - (defaultSelected.offsetWidth / 2) -
                            (this.carouselCenter / 3),
                        behavior: 'smooth',
                    });
                    this.selectedElement = defaultSelected;
                    this.isFirstSelected = defaultSelected.dataset.order == 0;
                    this.isLastSelected = defaultSelected.dataset.order == this.optionsLength - 1;
                }
            }
        },

        updateOption(option, noDefault = false) {
            // lodash isEqual, ===, Object.is() can be tricky
            if ((this.value && this.value.id != option.id) || noDefault) {
                this.$emit('input', option);
                this.scrollToSelected(option.id);
                this.$emit('update-cart-option', this.currentSelection);
            }
        },

        controlDir(dir = 1) {
            // 1st design revision, scrolls left / right (+/- 2 items), no selection
            if (dir == 1) { // right
                // its 4 now...
                this.carouselElem.scrollBy({top: 0, left: this.carouselCenter * 1.5, behavior: 'smooth'});
            } else { // left
                this.carouselElem.scrollBy({top: 0, left: -this.carouselCenter * 1.5, behavior: 'smooth'});
            }

            let osTimer = 225;
            if (this.weirdBrowser) {
                osTimer = 300;
            }

            setTimeout(() => {
                if (this.selectedElement) {
                    this.isFirstSelected = this.selectedElement.dataset.order == 0 &&
                        utilities.isElementInViewport(this.carouselElem, this.selectedElement);
                    this.isLastSelected = (this.selectedElement.dataset.order == this.optionsLength - 1) &&
                        utilities.isElementInViewport(this.carouselElem, this.selectedElement);
                }
            }, osTimer);
        },

        getOptionImage: function(option, placeholder) {
            let fallBackImgUrl = '/themes/prozis-mobile2/imgs/img-placeholder.jpg'; // add to desktop too?
            let optionType = this.optionType;
            
            let nwOption = optionType == 'optionId'
                ? option.images.filter(img => img.imageStatus == 'NW')
                : null;
            if (option.images.length && optionType && option.images.length >= 5) {
                switch (optionType) {
                    case 'optionId':
                        return !placeholder ? (!isEmpty(nwOption) ? nwOption[0].image : (!isEmpty(option.images[1])
                                ? option.images[1].image
                                : fallBackImgUrl))
                            : (!isEmpty(nwOption) ? nwOption[0].placeholderImage : (!isEmpty(option.images[1])
                                ? option.images[1].placeholderImage
                                : fallBackImgUrl));

                    default:
                        return !placeholder
                            ? !isEmpty(option.images)
                                ? option.images[1].image
                                : fallBackImgUrl
                            : option.images[1].placeholderImage
                                ? option.images[1].placeholderImage
                                : fallBackImgUrl;
                }
            } else {
                return fallBackImgUrl;
            }
        },
    },
    created() {
        this.$emit('input', this.value);
        // this may be needed in the future...
        /*bus.$on('update-single-carousel', values => {
            if (storeCombos.getters.noPreSelection) {
                if (this.defaultValue) {
                    if (values.length == 1) {
                        this.$emit('input', values[0]);
                    }
                }
            }
        });*/
    },
    mounted() {
        this.$nextTick(() => {
            this.carouselElem = this.$refs[this.elementId];
            //this.carouselCenter = this.carouselElem.getBoundingClientRect().width / 2;
            this.optionsLength = this.options.length;
            this.weirdBrowser = operatingSystem.isIOS();
            // default behaviour SAFEGUARD, with vue.set in pack items this now can be targeted for a "little" revision
            if (!this.defaultValue) {
                let defaultOption = this.options[0];
                this.updateOption(defaultOption, true);
            } else {
                // ja se pode simplificar isto acho eu (esperar pelo no default selected on carousels)
                this.updateOption(this.defaultValue, true); // should be for packs only
                //this.scrollToSelected(this.defaultValue.id);

            }
        });
    },
};
</script>

<style scoped>

</style>